import React from "react";
import styled from "styled-components";

const Divider = styled.div.attrs((props) => ({
  "data-before": props.$beforeItemId || "-1",
}))`
  margin-top: ${(props) => props.$margin};
  margin-bottom: ${(props) => props.$margin};
  height: 20px;
  width: 100%;
  background-color: #2399a1;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
`;

const DropIndicator = ({
  beforeItemId,
  onDragOver,
  onDragLeave,
  onDrop,
  margin = "2px", // some components have gap between items on it so we need to add negative margins in needed places to make it look good
}) => {
  return (
    <Divider
      $beforeItemId={beforeItemId}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      $margin={margin}
    />
  );
};

export default DropIndicator;
